'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _RenderHelper = require('./RenderHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderWarnings = function (_React$Component) {
    _inherits(RenderWarnings, _React$Component);

    function RenderWarnings() {
        _classCallCheck(this, RenderWarnings);

        return _possibleConstructorReturn(this, (RenderWarnings.__proto__ || Object.getPrototypeOf(RenderWarnings)).apply(this, arguments));
    }

    _createClass(RenderWarnings, [{
        key: 'mountWhitelistWarning',
        value: function mountWhitelistWarning() {
            if (this.props.whitelist) return false;
            return 'This domain "' + window.location.hostname + '" has not been whitelisted to show this quiz.';
        }
    }, {
        key: 'mountPolicyWarning',
        value: function mountPolicyWarning() {
            var _props = this.props,
                settings = _props.settings,
                data = _props.data,
                preview = _props.preview;

            if (!!settings) {
                var meta = settings.get('meta');
                if (!meta && !!preview) return false;
                meta = meta.toJS();

                var _ref = meta || {},
                    terms = _ref.terms;

                if ((!terms.text || !terms.link || !terms.url || data.get('isBrowserWrap') && !terms.bwtext) && !data.get('isPrivacyPolicyHidden')) {
                    return 'Privacy Policy has not been provided by this Activity\'s publisher';
                }
            }
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var messages = [this.mountWhitelistWarning(), this.mountPolicyWarning()].filter(function (w) {
                return !!w;
            });

            if (!messages.length) return null;

            return _react2.default.createElement(
                'div',
                { className: 'domain_warning' },
                messages.map(function (m, k) {
                    return _react2.default.createElement(
                        'div',
                        { key: k },
                        _react2.default.createElement(
                            'p',
                            null,
                            m
                        )
                    );
                })
            );
        }
    }]);

    return RenderWarnings;
}(_react2.default.Component);

exports.default = RenderWarnings;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/RenderWarnings.js
// module id = 225
// module chunks = 0